const LIKED_STUDIOS_STORAGE_KEY = 'latinplace.likedStudioIds.v1';

export function getLikedStudioIds(): number[] {
  if (!canUseLocalStorage()) {
    return [];
  }

  try {
    const rawValue = window.localStorage.getItem(LIKED_STUDIOS_STORAGE_KEY);
    if (!rawValue) {
      return [];
    }

    const parsedValue: unknown = JSON.parse(rawValue);
    if (!Array.isArray(parsedValue)) {
      return [];
    }

    return parsedValue.filter((value): value is number => Number.isInteger(value) && value > 0);
  } catch {
    return [];
  }
}

export function isStudioLiked(studioId: number): boolean {
  return getLikedStudioIds().includes(studioId);
}

export function setStudioLiked(studioId: number, liked: boolean): void {
  if (!canUseLocalStorage()) {
    return;
  }

  const likedStudioIds = new Set(getLikedStudioIds());

  if (liked) {
    likedStudioIds.add(studioId);
  } else {
    likedStudioIds.delete(studioId);
  }

  try {
    window.localStorage.setItem(LIKED_STUDIOS_STORAGE_KEY, JSON.stringify(Array.from(likedStudioIds)));
  } catch {
    // Ignore storage quota/private-mode failures. Server count still updates.
  }
}

function canUseLocalStorage(): boolean {
  try {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  } catch {
    return false;
  }
}
